'use strict';

/**
 *
 * data-sw-context-menu allows hide/show of a group of context sensitive options triggered by clicking on an element
 * once a context-menu is open, clicking anywhere on the page will close the menu
 *
 * Usage:
 *
 *   data-sw-context-menu
 *
 *   put on the context menu element
 *
 *
 *   data-sw-context-menu-control
 *
 *   pass a selector for the element(s) that should open the context menu when clicked
 *
 *
 *   data-sw-context-menu-control-open-class
 *
 *   a class to put on the control when it's menu is open
 *   Defaults to 'sw-context-menu-control-open'
 *
 *
 *   data-sw-context-menu-close-event
 *
 *   listens for this event and closes if it hears it
 *   Defaults to 'close-context-menus'
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');

var ATTRS = {
  ROOT: 'data-sw-context-menu',
  control: 'data-sw-context-menu-control',
  controlOpenClass: 'data-sw-context-menu-control-open-class',
  closeEvent: 'data-sw-context-menu-close-event'
};

var menuAttrSelector = swUtils.makeAttributeValueSelector(ATTRS.ROOT);

var HIDE_MENU_CLASS = 'sw--is-hidden';
var DEFAULT_OPEN_MENU_CONTROL_CLASS = 'sw-context-menu-control-open';
var DEFAULT_CLOSE_EVENT = 'close-context-menus';

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-context-menu]').each(function() {
    var $menu = $(this);
    var controlSelector = $menu.attr(ATTRS.control);
    var controlOpenClass = $menu.attr(ATTRS.controlOpenClass) ? $menu.attr(ATTRS.controlOpenClass) : DEFAULT_OPEN_MENU_CONTROL_CLASS;
    var $controlEls = $(controlSelector);
    var menuOpen = false;
    var closeMenuEvent = $menu.attr(ATTRS.closeEvent) ? $menu.attr(ATTRS.closeEvent) : DEFAULT_CLOSE_EVENT;

    function openMenu($controls) {
      $menu.removeClass(HIDE_MENU_CLASS);
      $controls.addClass(controlOpenClass);
      menuOpen = true;
    }

    function closeMenu($controls) {
      $menu.addClass(HIDE_MENU_CLASS);
      $controls.removeClass(controlOpenClass);
      menuOpen = false;
    }

    $controlEls.on('click', function eventHandler(e){
      var $control = $(this);

      if(menuOpen) {
        closeMenu($control);
      } else {
        sw.trigger(closeMenuEvent);
        openMenu($control);

        $('body').one('click', ':not(' + menuAttrSelector + ')', function eventHandler() {
          closeMenu($control);
        });

        e.stopPropagation();
      }
    });

    sw.listenTo(sw, closeMenuEvent, function(){
      closeMenu($controlEls);
    });
  });
};
